import { buildHashParam } from '../../../utils/buildHash';
import { Fetcher } from '../../Fetcher';

export interface IHelpChapter<T = string> {
  [key: string]: T | IHelpChapter<T>;
}

export interface HelpChapterProps {
  content: IHelpChapter | null;
  isStorybook?: boolean;
}

export interface IHelpFile {
  [key: string]: IHelpChapter;
}

export interface IFetchHelpParams {
  url: string;
  lang: string;
  hideAutoplay: boolean | undefined;
  hideSubtitles: boolean | undefined;
  gameType: string;
}

export const fetchGameHelp = ({
  url,
  lang,
  hideAutoplay,
  hideSubtitles,
  gameType,
}: IFetchHelpParams): Promise<IHelpFile> => {
  return Promise.all([
    // Fetch game-specific help file
    Fetcher.fetch<IHelpFile>(`${url}/${lang}/${gameType}.json`, buildHashParam),
    // Fetch common help file // TODO: make a generic solution instead of gameType hardcode. Manifest?
    Fetcher.fetch<IHelpFile>(
      `${url}/${lang}/${gameType === 'highflyer' ? 'commoncrash' : 'common'}.json`,
      buildHashParam
    ),
  ]).then(([gameHelpChapters, commonHelpChapters]): IHelpFile => {
    const helpFile = { ...gameHelpChapters, ...commonHelpChapters };
    // Conditionally remove autoplay chapter from help file
    if (hideAutoplay) {
      delete helpFile['autoplay'];
    }
    // Conditionally remove subtitles chapter from help file
    if (hideSubtitles) {
      delete helpFile['subtitles'];
    }
    return helpFile;
  });
};
